import { render, staticRenderFns } from "./tabs-header.vue?vue&type=template&id=213a886d&scoped=true&"
import script from "./tabs-header.vue?vue&type=script&lang=ts&"
export * from "./tabs-header.vue?vue&type=script&lang=ts&"
import style0 from "./tabs-header.vue?vue&type=style&index=0&id=213a886d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a886d",
  null
  
)

component.options.__file = "tabs-header.vue"
export default component.exports